
  import Vue from 'vue'
  import halson from './HALSONResource.coffee'
  import uuid from 'uuid/v4'
  import wsse from './auth/Wsse.coffee'
  import axios from 'axios'

  # axios.defaults.baseURL = 'http://localhost:8777'
  axios.defaults.baseURL = process.env.API_URL

  # user = 'hansw'
  # passwd = 'defccb4b0b49d5c3ccaf952f926397a2b53685ab7de86ca242b0010e5877d56dade0c45bb73ab7b0ed235ec60002f60b60d7817c27a3dfb98adf270c08c3a2ea'

  class XHR
    constructor: ->
      @auth_interceptor = null

    stripSlash: (url) ->
      url.replace(/^\//g, '')

    filter: (obj) ->
      result = {}
      for own key, value of obj
        if key.charAt(0) != '_' then result[key] = value
      result

    setUser: (user, passwd) ->
      if @auth_interceptor?
        axios.interceptors.request.eject @auth_interceptor
      @auth_interceptor = axios.interceptors.request.use (config) ->
        config.headers.common['X-WSSE'] = wsse.wsseHeader(user, passwd)
        config

    get: (url, params) ->
      url = @stripSlash url
      console.log 'get: ', url
      axios.get url, { params: params }
        .then (response) ->
          halson response.data

    put: (item) ->
      url = @stripSlash item.getLink('self').href
      console.log 'put: ', url, item

      axios.put url, @filter(item)
        .then (response) ->
          halson response.data

    post: (url, item) ->
      url = @stripSlash url
      # item.uid = uuid() if not item.uuid?
      console.log 'post: ', url, item

      axios.post url, @filter(item)
        .then (response) ->
          halson response.data

    delete: (item) ->
      url = @stripSlash item.getLink('self').href
      console.log 'delete: ', url, item

      axios.delete url
        .then (response) ->
          response.data

  export default XHR



// WEBPACK FOOTER //
// ./src/services/XHR.coffee